import {connect} from 'react-redux';

import MatchStats from '../MatchStats.jsx';

function select(state, props) {
    return {
        ...props
    };
}

export default connect(select)(MatchStats);



// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/live/MatchStats.jsx